import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import TotalCostAmount from '../containers/current-total-cost-range.container';
import PurchaseDate from './purchase-date';
import PurchaseInventoryStatusContainer from '../containers/purchase-inventory-status.container';

import Purchase from '../lib/purchase';

class PurchaseKeyInfo extends Component {
  renderEventStarts() {
    const { product } = this.props.purchase;

    if (!product.startDatetime) return null;

    return (
      <div className="col-3">
        <PurchaseDate
          date={product.startDatetime}
          timezone={product.startDatetimeTimezone}
          label={
            <FormattedMessage
              id="keyInfo.eventStarts"
              defaultMessage="Event starts"
            />
          }
        />
      </div>
    );
  }

  renderEventEnds() {
    const { product } = this.props.purchase;

    if (!product.endDatetime) return null;

    return (
      <div className="col-3">
        <PurchaseDate
          date={product.endDatetime}
          timezone={product.endDatetimeTimezone}
          label={
            <FormattedMessage
              id="keyInfo.eventEnds"
              defaultMessage="Event ends"
            />
          }
        />
      </div>
    );
  }

  render() {
    const { purchase } = this.props;
    const isCanceled = Purchase.isCanceled(purchase.status);

    return (
      <div className="key-info row">
        <div className="col-3">
          <TotalCostAmount />
        </div>
        {this.renderEventStarts()}
        {this.renderEventEnds()}
        {!isCanceled && (
          <div className="col-3">
            <PurchaseInventoryStatusContainer />
          </div>
        )}
      </div>
    );
  }
}

export default PurchaseKeyInfo;



// WEBPACK FOOTER //
// ./src/desktop/components/purchase-key-info.js